"use strict";

var _createForOfIteratorHelper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("cross-fetch/polyfill");

var utils_1 = require("@netgum/utils");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var ApiError_1 = require("./ApiError");

var Api = /*#__PURE__*/function () {
  function Api(options) {
    var webSocketConstructor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var state = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Api);

    this.options = options;
    this.webSocketConstructor = webSocketConstructor;
    this.state = state;
    this.wsEndpoint = null;
    this.httpEndpoint = null;
    var host = options.host,
        port = options.port,
        ssl = options.ssl;
    var endpointBase = "".concat(ssl ? 's' : '', "://").concat(host || 'localhost').concat(port ? ":".concat(port) : '');
    this.wsEndpoint = "ws".concat(endpointBase);
    this.httpEndpoint = "http".concat(endpointBase);

    if (!webSocketConstructor && typeof WebSocket !== 'undefined') {
      this.webSocketConstructor = WebSocket;
    }
  }

  _createClass(Api, [{
    key: "toEthProvider",
    value: function toEthProvider(customError) {
      var _this = this;

      return {
        sendAsync: function sendAsync(body, callback) {
          _this.sendRequest({
            body: body,
            path: '',
            method: 'POST',
            dontUseReplacer: true
          }).catch(function (err) {
            return callback(customError ? new customError(err) : err, null);
          }).then(function (data) {
            return callback(null, data);
          });
        }
      };
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(req) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var method, path, body, dontUseReplacer, status, data, options, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = req.method, path = req.path, body = req.body, dontUseReplacer = req.dontUseReplacer;
                status = null;
                data = null;
                _context.prev = 3;
                options = Object.assign({
                  method: method,
                  headers: new Headers({
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                    'X-Session-Token': this.state.sessionToken || '',
                    Pragma: 'no-cache'
                  })
                }, method !== 'GET' && method !== 'HEAD' ? {
                  body: JSON.stringify(body || {}, dontUseReplacer ? undefined : utils_1.jsonReplacer)
                } : {});
                _context.next = 7;
                return fetch("".concat(this.httpEndpoint, "/").concat(path || ''), options);

              case 7:
                res = _context.sent;
                status = res.status;
                _context.t0 = JSON;
                _context.next = 12;
                return res.text();

              case 12:
                _context.t1 = _context.sent;
                _context.t2 = dontUseReplacer ? undefined : utils_1.jsonReviver;
                data = _context.t0.parse.call(_context.t0, _context.t1, _context.t2);
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t3 = _context["catch"](3);
                data = {};

              case 20:
                _context.t4 = status;
                _context.next = _context.t4 === 400 ? 23 : _context.t4 === 401 ? 24 : _context.t4 === 403 ? 25 : _context.t4 === 404 ? 26 : _context.t4 === 500 ? 27 : _context.t4 === null ? 27 : 28;
                break;

              case 23:
                throw new ApiError_1.ApiError(ApiError_1.ApiError.Types.BadRequest, data);

              case 24:
                throw new ApiError_1.ApiError(ApiError_1.ApiError.Types.Unauthorized, data);

              case 25:
                throw new ApiError_1.ApiError(ApiError_1.ApiError.Types.Forbidden, data);

              case 26:
                throw new ApiError_1.ApiError(ApiError_1.ApiError.Types.NotFound, data);

              case 27:
                throw new ApiError_1.ApiError(ApiError_1.ApiError.Types.Failed, data);

              case 28:
                return _context.abrupt("return", data);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 17]]);
      }));
    }
  }, {
    key: "event$",
    get: function get() {
      var _this2 = this;

      var result = new rxjs_1.Subject();

      var disconnect = function disconnect() {
        return null;
      };

      var subscriptions = [];

      if (this.webSocketConstructor) {
        var _this$state = this.state,
            connected$ = _this$state.connected$,
            session$ = _this$state.session$;
        var reconnected$ = new rxjs_1.Subject();
        var ws = null;

        var openHandler = function openHandler() {
          return connected$.next(true);
        };

        var closeHandler = function closeHandler() {
          connected$.next(false);
          reconnected$.next(true);
        };

        var errorHandler = function errorHandler() {
          return ws.close();
        };

        var messageHandler = function messageHandler(_ref) {
          var data = _ref.data;

          try {
            var message = JSON.parse(data, utils_1.jsonReviver);

            if (message) {
              result.next(message);
            }
          } catch (err) {//
          }
        };

        var connect = function connect() {
          var sessionToken = _this2.state.sessionToken;

          if (!ws && sessionToken) {
            connected$.next(null);
            ws = new _this2.webSocketConstructor("".concat(_this2.wsEndpoint, "?sessionToken=").concat(sessionToken));
            ws.binaryType = 'blob';
            ws.addEventListener('open', openHandler);
            ws.addEventListener('close', closeHandler);
            ws.addEventListener('error', errorHandler);
            ws.addEventListener('message', messageHandler);
          }
        };

        disconnect = function disconnect() {
          if (ws) {
            connected$.next(false);
            ws.removeEventListener('open', openHandler);
            ws.removeEventListener('close', closeHandler);
            ws.removeEventListener('error', errorHandler);
            ws.removeEventListener('message', messageHandler);
            ws.close();
            ws = null;
          }
        };

        subscriptions.push(session$.subscribe(function (session) {
          return session ? connect() : disconnect();
        }));
        var reconnectTimeout = this.options.reconnectTimeout;

        if (reconnectTimeout) {
          subscriptions.push(reconnected$.pipe(operators_1.delay(reconnectTimeout)).subscribe(function () {
            disconnect();
            connect();
          }));
        }
      }

      var complete = result.complete.bind(result);

      result.complete = function () {
        var _iterator = _createForOfIteratorHelper(subscriptions),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var subscription = _step.value;
            subscription.unsubscribe();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        disconnect();
        complete();
      };

      return result;
    }
  }]);

  return Api;
}();

exports.Api = Api;

(function (Api) {
  var EventNames;

  (function (EventNames) {
    EventNames["AccountUpdated"] = "AccountUpdated";
    EventNames["AccountVirtualBalanceUpdated"] = "AccountVirtualBalanceUpdated";
    EventNames["AccountDeviceUpdated"] = "AccountDeviceUpdated";
    EventNames["AccountDeviceRemoved"] = "AccountDeviceRemoved";
    EventNames["AccountFriendRecoveryUpdated"] = "AccountFriendRecoveryUpdated";
    EventNames["AccountTransactionUpdated"] = "AccountTransactionUpdated";
    EventNames["AccountPaymentUpdated"] = "AccountPaymentUpdated";
    EventNames["AccountGameUpdated"] = "AccountGameUpdated";
    EventNames["SecureCodeSigned"] = "SecureCodeSigned";
  })(EventNames = Api.EventNames || (Api.EventNames = {}));
})(Api = exports.Api || (exports.Api = {}));